import React from 'react'
import { useAuthContext } from '../contexts/AuthContext'
import AuthForm from './AuthForm'

const AuthWrapper = ({ children }) => {
  const { session, loading } = useAuthContext()

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500"></div>
      </div>
    )
  }

  if (!session) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900 p-6">
        <AuthForm />
      </div>
    )
  }

  return children
}

export default AuthWrapper 